import { getJson } from "../../auth/utils/getJson.js";  
import { apiFetch } from "../../auth/api/apiFetch.js";  

/** GET /api/meters */
export function fetchMeters(signal) {
  return getJson("/api/meters", { signal });
}

/** GET /api/meters/:meterNumber */
export function fetchMeter(meterNumber, { unit, evn } = {}, signal) {
  const qs = new URLSearchParams();
  if (unit) qs.set("unit", unit);
  if (evn) qs.set("evn", evn);

  const query = qs.toString();
  const url = `/api/meters/${encodeURIComponent(meterNumber)}${query ? `?${query}` : ""}`;

  return getJson(url, { signal });
}

/** GET /api/meters/:meterNumber/files?unit=...&evn=... */
export function fetchMeterFiles(meterNumber, unit, evn, signal) {
  const qs = new URLSearchParams();
  if (unit !== undefined && unit !== null && String(unit) !== '') qs.set('unit', String(unit));
  if (evn !== undefined && evn !== null && String(evn) !== '') qs.set('evn', String(evn));

  const path = `/api/meters/${encodeURIComponent(meterNumber)}/files${qs.toString() ? `?${qs.toString()}` : ''}`;
  return getJson(path, { signal });
}

/** GET /api/dataQuality?meter=...&fromDate=...&toDate=...&evn=... */
export function fetchMeterQuality(meterNumber, { fromDate, toDate, evn } = {}, signal) {
  const qs = new URLSearchParams();
  if (meterNumber) qs.set("meter", String(meterNumber));
  if (fromDate) qs.set("fromDate", fromDate);
  if (toDate) qs.set("toDate", toDate);
  if (evn !== undefined && evn !== null && String(evn) !== '') qs.set('evn', String(evn));
  return getJson(`/api/dataQuality?${qs.toString()}`, { signal });
}

/** GET /api/meters/:meterNumber/versions */
export function fetchMeterVersions(meterNumber, signal) {
  return getJson(`/api/meters/${encodeURIComponent(meterNumber)}/versions`, { signal });
}

/** GET /api/energy/summary?meter=...&train=...&operator=...&from=...&to=...&evn=... */
export function fetchEnergySummary({ meter, train, operator, from, to, evn }, signal) {
  const qs = new URLSearchParams();
  if (meter) qs.set("meter", meter);
  if (train) qs.set("train", train);
  if (operator) qs.set("operator", operator);
  if (from) qs.set("from", from);
  if (to) qs.set("to", to);
  if (evn !== undefined && evn !== null && String(evn) !== '') qs.set('evn', String(evn));
  return getJson(`/api/energy/summary?${qs.toString()}`, { signal });
}

/** POST /api/meters/modify */
export async function modifyMeter(payload, signal) {
  const res = await apiFetch("/api/meters/modify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json?.error || "Failed to modify meter");
  return json;
}
